import { useEffect } from 'react';
/** Rola o fio até o fim. `suave` anima; seco é para quem acabou de voltar para a aba. */
function rolar(alvo, suave) {
    alvo?.scrollIntoView({ behavior: suave ? 'smooth' : 'auto' });
}
/**
 * Mantém o fio de conversa colado na última mensagem.
 *
 * Duas armadilhas do navegador moram aqui, e as duas custaram tempo para aparecer:
 *
 * 1. **Rolar no mesmo quadro em que a bolha entra não funciona.** O navegador ainda não
 *    mediu o elemento novo, e a última mensagem fica metade escondida atrás do campo de
 *    escrever. Por isso o `requestAnimationFrame`.
 *
 * 2. **Aba escondida não roda `requestAnimationFrame`** — e, mesmo que rodasse, a rolagem
 *    suave não anima fora da tela. O efeito, visto em teste em 06/10: com o painel atrás
 *    de outra janela, três mensagens chegaram e o fio ficou parado onde estava; quem
 *    voltava encontrava a conversa no meio, com o que era novo abaixo da dobra. Por isso a
 *    rolagem fica marcada para quando a pessoa voltar, e aí é um salto seco: animar um
 *    pulo de várias telas na cara de quem acabou de chegar não ajuda ninguém.
 *
 * O `marcador` é o que diz "chegou mensagem": tipicamente o id da conversa junto do total
 * de mensagens. Um valor só, em vez de uma lista de dependências, para o uso ser igual em
 * todos os fios.
 */
export function useRolagemDoFim(alvo, marcador) {
    useEffect(() => {
        if (document.visibilityState === 'visible') {
            const id = requestAnimationFrame(() => rolar(alvo.current, true));
            return () => cancelAnimationFrame(id);
        }
        const aoVoltar = () => {
            if (document.visibilityState !== 'visible')
                return;
            // Duas vezes, e não é desleixo: a primeira usa o que já está medido (o normal, porque
            // as mensagens chegaram enquanto a aba estava escondida) e a segunda corrige no
            // quadro seguinte, caso a volta à tela ainda mude alguma altura.
            rolar(alvo.current, false);
            requestAnimationFrame(() => rolar(alvo.current, false));
        };
        document.addEventListener('visibilitychange', aoVoltar);
        return () => document.removeEventListener('visibilitychange', aoVoltar);
    }, [alvo, marcador]);
}
//# sourceMappingURL=rolagem.js.map